import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/macro';

import { PageTitle } from '../../components/PageTitle';
import {
  BasePageContainer,
  CommandsContainer as TitleContainer,
} from '../Common/styles';
import { BrowserExtensionsDownloadColumn } from './components/BrowserExtensionsDownloadColumn';

const DownloadsPageContainer = styled(BasePageContainer)``;

export const DownloadsPage = () => {
  const { t } = useTranslation();

  return (
    <DownloadsPageContainer>
      <Row>
        <TitleContainer>
          <PageTitle title={t('downloads:mainTitle')} />
        </TitleContainer>
      </Row>
      <Row>
        <Col xs={24} lg={12} xl={8}>
          <BrowserExtensionsDownloadColumn />
        </Col>
      </Row>
    </DownloadsPageContainer>
  );
};
